import * as styled from '../styles/success';

type Props = {
  reviewerName: string;
};

export const SuccessScreen = ({ reviewerName }: Props) => (
  <styled.Container>
    <styled.Card>
      <styled.Icon>✅</styled.Icon>
      <styled.Title>
        Thank you{reviewerName ? `, ${reviewerName}` : ''}!
      </styled.Title>
      <styled.Subtitle>
        Your review has been submitted successfully. Your feedback helps build
        trust in the community.
      </styled.Subtitle>
    </styled.Card>
  </styled.Container>
);
